import { Controller } from "@hotwired/stimulus"

export default class MobileNavbarController extends Controller {
  static targets = ["wrapper", "search"]

  showMenu() {
    this.wrapperTarget.classList.add("fixed")
    this.wrapperTarget.classList.remove("hidden")
    this.hideSearch()
  }

  hideMenu() {
    this.wrapperTarget.classList.add("hidden")
    this.wrapperTarget.classList.remove("fixed")
    this.hideSearch()
  }

  showSearch() {
    this.hideMenu()

    this.searchTarget.classList.add("fixed")
    this.searchTarget.classList.remove("hidden")
  }

  hideSearch() {
    this.searchTarget.classList.remove("fixed")
    this.searchTarget.classList.add("hidden")
  }
}
